// src/services/api/articles.api.ts
import { apiRequest } from "./client";
import {
    ArticleItem,
    ArticlesPageResponse,
    ListArticlesFilters,
    ArticleUpsertPayload,
} from "../types/articles.types";

export const getArticlesRequest = async (
    page: number,
    pageSize: number,
    filters: ListArticlesFilters = {},
): Promise<ArticlesPageResponse> => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("page_size", String(pageSize));

    if (filters.search_name?.trim()) {
        params.set("search_name", filters.search_name.trim());
    }

    if (filters.is_published !== null && filters.is_published !== undefined) {
        params.set("is_published", String(filters.is_published));
    }

    return apiRequest<ArticlesPageResponse>(`/articles?${params.toString()}`, {
        method: "GET",
        auth: true,
    });
};

export const getArticleRequest = async (articleId: string): Promise<ArticleItem> => {
    return apiRequest<ArticleItem>(`/articles/${articleId}`, {
        method: "GET",
        auth: true,
    });
};

export const createArticleRequest = async (
    payload: ArticleUpsertPayload,
): Promise<ArticleItem> => {
    return apiRequest<ArticleItem>("/articles", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
        auth: true,
    });
};

export const updateArticleRequest = async (
    articleId: string,
    payload: Partial<ArticleUpsertPayload>,
): Promise<ArticleItem> => {
    return apiRequest<ArticleItem>(`/articles/${articleId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
        auth: true,
    });
};

export const deleteArticleRequest = async (articleId: string): Promise<void> => {
    return apiRequest<void>(`/articles/${articleId}`, {
        method: "DELETE",
        auth: true,
    });
};

export const uploadArticleCoverRequest = async (
    articleId: string,
    file: File,
): Promise<ArticleItem> => {
    const formData = new FormData();
    formData.append("file", file);

    return apiRequest<ArticleItem>(`/articles/upload-cover/${articleId}`, {
        method: "POST",
        body: formData,
        auth: true,
    });
};

export const uploadArticlePhotoRequest = async (
    articleId: string,
    file: File,
): Promise<ArticleItem> => {
    const formData = new FormData();
    formData.append("file", file);

    return apiRequest<ArticleItem>(`/articles/upload-photo/${articleId}`, {
        method: "POST",
        body: formData,
        auth: true,
    });
};

export const deleteArticlePhotoRequest = async (
    articleId: string,
    photoUrl: string,
): Promise<ArticleItem> => {
    return apiRequest<ArticleItem>(`/articles/${articleId}/photos`, {
        method: "DELETE",
        body: JSON.stringify({ photo_url: photoUrl }),
        headers: { "Content-Type": "application/json" },
        auth: true,
    });
};
